export default __webpack_public_path__ + "fonts/37572120d4085171193cab4410c7c4d1.svg";